import { render, staticRenderFns } from "./ListPromo.vue?vue&type=template&id=00bd622f&scoped=true"
import script from "./ListPromo.vue?vue&type=script&lang=js"
export * from "./ListPromo.vue?vue&type=script&lang=js"
import style0 from "./ListPromo.vue?vue&type=style&index=0&id=00bd622f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd622f",
  null
  
)

export default component.exports